import React from "react";
import MarketingLayout from "../components/marketing/MarketingLayout";
import Seo, { ORG_JSON_LD } from "../components/marketing/Seo";

/**
 * Generic legal/policy page wrapper with consistent typography & SEO.
 */
export default function LegalPage({
  seoTitle,
  seoDescription,
  seoKeywords,
  path,
  heading,
  tagline,
  lastUpdated = "February 2026",
  children,
}) {
  return (
    <MarketingLayout>
      <Seo
        title={seoTitle}
        description={seoDescription}
        keywords={seoKeywords}
        path={path}
        jsonLd={ORG_JSON_LD}
      />

      <section className="border-b border-[#E2E8F0] bg-gradient-to-br from-[#F0F4FF] via-white to-[#FFF1F8]">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 py-16 lg:py-24">
          <span className="text-xs font-mono uppercase tracking-widest text-[#0044FF]">{tagline}</span>
          <h1 className="font-display font-extrabold text-4xl md:text-6xl mt-3 leading-[0.95] tracking-tight">{heading}</h1>
          <p className="text-sm font-mono text-[#4B5563] mt-6">Last updated · {lastUpdated}</p>
        </div>
      </section>

      <section className="py-16 lg:py-20">
        <article className="max-w-3xl mx-auto px-6 lg:px-10 prose prose-slate prose-headings:font-display prose-headings:font-bold prose-h2:text-3xl prose-h2:mt-12 prose-h2:mb-4 prose-h3:text-xl prose-h3:mt-8 prose-h3:mb-3 prose-p:text-[#374151] prose-p:leading-relaxed prose-li:text-[#374151] prose-a:text-[#0044FF] hover:prose-a:underline">
          {children}
        </article>
      </section>
    </MarketingLayout>
  );
}
